
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DetailInfo',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
});
